import React, { Component } from 'react';
import { Button, Card, CardActions, CardContent, CardHeader, Icon, IconButton } from '@material-ui/core';
import TableWithoutPagination from '../Table/TableWithoutPagination';
import moment from 'moment'
import { connect } from 'react-redux';
import { compose } from 'redux';
import { loadIntervention, loadPlannedInterventions } from '../../redux/intervention/extranetInterventionActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from "@fortawesome/free-solid-svg-icons";
import { withRouter } from 'react-router-dom';
import { NB_MAX_PLANNED_INTERVENTION_TO_DISPLAY } from '../../redux/intervention/extranetInterventionConstants';

class PlannedInterventions extends Component {

    constructor(props) {
        super(props);

        this.state = {
            columns: [
                {
                    columns: [
                        {
                            Header: "Date",
                            width: 120,
                            id: 'date_planned_start',
                            accessor: i => moment(i.date_planned_start).format("DD/MM/YY HH:mm"),
                        },
                        {
                            Header: "Num",
                            width: 80,
                            id: 'name',
                            accessor: "name",
                        },
                        {
                            Header: "Description",
                            id: 'failure_description',
                            accessor: "failure_description",
                        },
                    ]
                },
            ]
        }
        
        this.props.loadPlannedInterventions(this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.interventions, this.props.tableState.nbTotalResults);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sites.selectedSite !== this.props.sites.selectedSite)
            this.props.loadPlannedInterventions(this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.interventions, this.props.tableState.nbTotalResults);
    }

    goToInterventions(e) {
        this.props.history.push("/interventions");
        e.stopPropagation();
    }

    loadIntervention(e, intervention) {
        this.props.loadIntervention(intervention);
        this.props.history.push("/interventions/intervention");
        this.props.globalContainer.current.scrollTop = 0

        e.stopPropagation();
    }

    getTableTrProps(state, rowInfo) {
        if (rowInfo && rowInfo.row) {
            return {
                onClick: e => this.loadIntervention(e, rowInfo.row._original),
                style: {
                    cursor: 'pointer'
                },
            }
        } else {
            return {}
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={this.props.className}>
                <Card className="card without-padding full-height" onClick={this.goToInterventions.bind(this)}>
                    <CardHeader title={"Mes prochaines interventions"} titleTypographyProps={{ variant: "h6", color: 'primary' }}
                        avatar={<FontAwesomeIcon icon={faClipboardList} className={classes.faIconStyle} alt="Interventions" />} action={
                            <IconButton color="inherit" onClick={this.props.close} aria-label="Close">
                                <Icon>close</Icon>
                            </IconButton>
                        }
                    />
                    <CardContent className="without-padding">
                        <TableWithoutPagination
                            data={this.props.interventions.filteredAndSortedInterventions}
                            columns={this.state.columns}
                            pageSize={NB_MAX_PLANNED_INTERVENTION_TO_DISPLAY}
                            minRows={NB_MAX_PLANNED_INTERVENTION_TO_DISPLAY}
                            sortable={false}
                            getTrProps={this.getTableTrProps.bind(this)}
                        />
                    </CardContent>
                    <CardActions className={classes.cardActions} disableSpacing>
                        <Button variant="contained" size="small" color="secondary" onClick={this.goToInterventions.bind(this)}
                            startIcon={<Icon>arrow_forward</Icon>} className={classes.smallButton}>
                            Voir plus
                    </Button>
                    </CardActions>
                </Card>
            </div >
        );
    }
}

const mapStateToProps = (state) => {
    return {
        interventions: state.extranetInterventions,
        activeUser: state.activeUser,
        tableState: state.tableState,
        sites: state.sites,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        loadPlannedInterventions: (user, customerSiteId, allSites, interventionsFilters, nbTotalResults) => 
        dispatch(loadPlannedInterventions(user, customerSiteId, allSites, interventionsFilters, nbTotalResults)),
        loadIntervention: (intervention) => dispatch(loadIntervention(intervention)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(PlannedInterventions);
